var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"6px","opacity":"0.2"},style:({'direction': _vm.$vs.rtl ? 'rtl' : 'ltr'})},[_c('feather-icon',{attrs:{"icon":"SquareIcon","svgClasses":"h-6 w-6 cursor-none"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }